










import { Component, Mixins } from "vue-property-decorator"

import { ImageMixin, SpacingMixin, WidgetMixin } from "./mixins"

@Component
export default class WBanner extends Mixins(WidgetMixin, ImageMixin, SpacingMixin) {}
